import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function ChildDocumentIcon({
  className,
  dataCy,
  fill = IconColors.DarkGrey,
  height = 16,
  style,
  width = 16,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      dataCy={dataCy}
      fill="none"
      height={height}
      style={style}
      viewBoxDimensions="0 0 16 16"
      width={width}
    >
      <path
        d="M11.6938 1.125C11.9331 1.12486 12.1632 1.2187 12.3345 1.38574L14.1401 3.14746C14.317 3.31995 14.4165 3.55666 14.4165 3.80371V13.958C14.4165 14.4642 14.0066 14.8748 13.5005 14.875H2.50049C1.99423 14.875 1.5835 14.4643 1.5835 13.958V2.04199C1.5835 1.53573 1.99423 1.125 2.50049 1.125H11.6938ZM4.36084 10.708C4.08488 10.7081 3.86102 10.9321 3.86084 11.208C3.86084 11.4841 4.08477 11.7079 4.36084 11.708H8.02783C8.3039 11.7079 8.52783 11.4841 8.52783 11.208C8.52766 10.9321 8.30379 10.7081 8.02783 10.708H4.36084ZM4.36084 7.95801C4.08488 7.95809 3.86102 8.18207 3.86084 8.45801C3.86084 8.7341 4.08477 8.95792 4.36084 8.95801H11.6938C11.97 8.95801 12.1938 8.73415 12.1938 8.45801C12.1937 8.18202 11.9699 7.95801 11.6938 7.95801H4.36084ZM4.36084 5.20801C4.08488 5.20809 3.86102 5.43207 3.86084 5.70801C3.86084 5.9841 4.08477 6.20792 4.36084 6.20801H11.6938C11.97 6.20801 12.1938 5.98415 12.1938 5.70801C12.1937 5.43202 11.9699 5.20801 11.6938 5.20801H4.36084Z"
        fill={fill}
      />
    </SimpleIcon>
  );
}
